export const data = [
    {
        id: "0",
        question: "What is the difference between hammer and mallet?",
        answer: "A hammer is used for nails, and a mallet is used when you want to avoid leaving markings.",
        variants: [`A hammer is used to hit something into place, while a mallet is used to free a stuck object.`, `A hammer is used for nails, and a mallet is used when you want to avoid leaving markings.`, `They are both used for murder.`, `There is no difference.`]
    },
    {
        id: "1",
        question: "What is the difference between drills and impact drivers?",
        answer: "Drills are intended to drill holes, while impact drivers are used to insert screws.",
        variants: [`Drills are intended to drill holes, while impact drivers are used to insert screws.`, `Impact drivers are manually powered, while drills have motors.`, `They are both harmless.`, `There is no difference.`]
    },
    {
        id: "2",
        question: "What is an Arbor Press used for?",
        answer: "",
        variants: [`Bending metal.`, `Creating metal cutouts.`, `Inserting parts into tight spaces.`, `Making stamps.`]
    },
    {
        id: "3",
        question: "What is a CNC router?",
        answer: "A machine that cuts metal in a given path.",
        variants: [`A mechanism for routing robot wires.`, `A portable router.`, `Another name for a drill press.`, `A machine that cuts metal along a defined path.`]
    },
    {
        id: "4",
        question: "What is a Press Brake?",
        answer: "Used to bend metal.",
        variants: [`A machine for bending wood.`, `Used to flatten metal stock.`, `Used to stop a robot manually.`, `Used to bend metal.`]
    },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },